<template>
  <!-- Modal -->
  <div v-if="isModalOpen" class="modal" @click.self="closeModal">
    <div class="modal-content">
      <div class="row mb-2" style="padding: 0 15px 0 15px">
        <div class="col col-6">
          <img
            src="@/assets/images/symbol_blue.svg"
            alt=""
            style="padding: 0; height: 30px; width: 30px"
          />
        </div>
        <div class="col col-6">
          <ButtonClose fontSize="16" @btnAbort="closeModal" />
        </div>
      </div>
      <h2>{{ dMessages.title }}</h2>
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <label for="name">{{ dMessages.firstName }} *</label>
          <input
            v-model="form.name"
            type="text"
            id="name"
            name="name"
            :class="{ error: errors.name }"
          />
        </div>
        <div class="form-group">
          <label for="lastName">{{ dMessages.lastName }} *</label>
          <input
            v-model="form.lastName"
            type="text"
            id="lastName"
            name="lastName"
            :class="{ error: errors.lastName }"
          />
        </div>
        <div class="form-group">
          <label for="company">{{ dMessages.company }} *</label>
          <input
            v-model="form.company"
            type="text"
            id="company"
            name="company"
            :class="{ error: errors.company }"
          />
        </div>
        <div class="form-group">
          <label for="email">{{ dMessages.email }} *</label>
          <input
            v-model="form.email"
            type="email"
            id="email"
            name="email"
            :class="{ error: errors.email }"
          />
        </div>
        <div class="form-group">
          <label for="telephone">{{ dMessages.phone }}</label>
          <input
            v-model="form.telephone"
            type="tel"
            id="telephone"
            name="telephone"
          />
        </div>
        <button type="submit" class="btn">{{ dMessages.submit }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import ButtonClose from "@/components/buttons/Close.vue";

export default {
  name: "DemoModal",
  components: { ButtonClose },
  props: {
    dMessages: { required: true, default: () => [] },
    isModalOpen: { required: true, type: Boolean, default: false },
  },
  data() {
    return {
      form: {
        name: "",
        lastName: "",
        company: "",
        email: "",
        telephone: "",
      },
      errors: {
        name: false,
        lastName: false,
        company: false,
        email: false,
      },
      toastGroup: "modalToast",
    };
  },
  methods: {
    closeModal() {
      this.$emit("eventOnCloseModal", false);
      this.resetForm();
      this.resetErrors();
    },
    submitForm() {
      // Reiniciar errores
      this.resetErrors();

      // Validar campos requeridos
      let isValid = true;
      if (!this.form.name) {
        this.errors.name = true;
        isValid = false;
      }
      if (!this.form.lastName) {
        this.errors.lastName = true;
        isValid = false;
      }
      if (!this.form.company) {
        this.errors.company = true;
        isValid = false;
      }
      if (!this.form.email) {
        this.errors.email = true;
        isValid = false;
      } else if (!this.isValidEmail(this.form.email)) {
        this.errors.email = true;
        isValid = false;
      }

      if (isValid) {
        // Aquí puedes manejar el envío del formulario (por ejemplo, una llamada API)
        this.validateForm();
      }
    },
    validateForm() {
      try {
        console.log("Formulario enviado:", this.form);
        this.$toast.add({
          severity: "success",
          summary: this.dMessages.toastSucces.title,
          detail: this.dMessages.toastSucces.message,
          life: 5000,
        });
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
        this.$toast.add({
          severity: "error",
          summary: this.dMessages.toastError.title,
          detail: this.dMessages.toastError.message,
          life: 5000,
        });
      }
      this.closeModal();
    },
    resetForm() {
      this.form = {
        name: "",
        lastName: "",
        company: "",
        email: "",
        telephone: "",
      };
    },
    resetErrors() {
      this.errors = {
        name: false,
        lastName: false,
        company: false,
        email: false,
      };
    },
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: var(--blacker-gray);
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 8px rgba(255, 255, 255, 0.2);
}
.modal-content h2 {
  margin-top: 0;
  font-size: 1.6rem;
  color: var(--white);
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: var(--white-gray);
}
.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--white);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--white);
}
.form-group input.error {
  border-color: var(--red);
}
.btn {
  background: var(--logo-blue);
  color: var(--white);
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}
.btn:hover {
  transform: scale(1.05);
  color: var(--white);
}
</style>
